import request from '@/utils/request'


export function getNextQualityChecker (data) {
  var method = 'post'
  var url = '/getNextQualityChecker' 
  return request({
    url,
    method,
    data
  })
}
